import 'slick-carousel/slick/slick.css'
import 'slick-carousel'

// Product details
if ($('.js-product-detail-carousel').length) {
  $('.js-product-detail-carousel').slick({
    autoplay: false,
    autoplaySpeed: 5000,
    dots: true,
    slidesToShow: 2,
    slidesToScroll: 2,

    // SP
    responsive: [{
      breakpoint: 750,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    }]
  })

  $('.slick-prev').attr('data-ga-event-label', 'product-detail-carousel-prev').addClass('gaClick')
  $('.slick-next').attr('data-ga-event-label', 'product-detail-carousel-next').addClass('gaClick')
  $('.slick-dots li button').each(function(index, element){
    $(element).attr('data-ga-event-label', 'product-detail-carousel-dot-' + index)
    $(element).addClass('gaClick')
  })
}
